import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Box, Drawer, Typography, Divider } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import useResponsive from '../../hooks/useResponsive';
import Scrollbar from '../../components/scrollbar';
import NavSection from '../../components/nav-section';
import borrowerNavConfig from './borrowerNavConfig';
import { useBorrowerLoan } from './BorrowerLoanContext';

const NAV_WIDTH = 280;

BorrowerNav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

export default function BorrowerNav({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');
  const { loanId, loan } = useBorrowerLoan();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const navItems = borrowerNavConfig(loanId);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box
        sx={{ px: 4, py: 3, display: 'inline-flex', cursor: 'pointer' }}
        onClick={() => navigate('/borrower/loans')}
      >
        <img src="/assets/logo-jet2.png" width={200} alt="Logo" />
      </Box>

      {/* Loan summary card */}
      {loan?.loanNumber && (
        <Box sx={{ mx: 2.5, mb: 2, p: 2, borderRadius: 1.5, bgcolor: 'grey.100' }}>
          <Typography variant="subtitle2" fontWeight={700} noWrap>
            Loan #{loan.loanNumber}
          </Typography>
          {loan.borrowerName && (
            <Typography variant="caption" color="text.secondary" noWrap display="block">
              {loan.borrowerName}
            </Typography>
          )}
          {loan.streetAddress && (
            <Typography variant="caption" color="text.secondary" noWrap display="block" sx={{ mt: 0.5 }}>
              {loan.streetAddress}
              {loan.streetCity ? `, ${loan.streetCity}` : ''}
              {loan.state ? `, ${loan.state}` : ''}
            </Typography>
          )}
        </Box>
      )}

      <Divider sx={{ mb: 1 }} />

      <NavSection data={navItems} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: NAV_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
